import fidelityComments from '../widgets/fidelityComments';
import summaryCallouts from '../widgets/summaryCallouts';
import overallFidelityChart from '../widgets/overallFidelityChart';
import overallFidelityInfoTab from '../widgets/overallFidelityInfoTab';
import fidelityComponentsChart from '../widgets/fidelityComponentsChart';
import fidelityAdherenceChart from '../widgets/fidelityAdherenceChart';
import componentsCallouts from '../widgets/componentsCallouts';
import componentsInfoTab from '../widgets/componentsInfoTab';
import fidelitySummaryTable from '../widgets/fidelitySummaryTable';
import fidelityAdherenceTable from '../widgets/fidelityAdherenceTable';
import summaryTableInfoTab from '../widgets/summaryTableInfoTab';
import recommendations from '../widgets/recommendations';

export default [
    summaryCallouts,
    overallFidelityChart,
    overallFidelityInfoTab,
    fidelityComponentsChart,
    fidelitySummaryTable,
    summaryTableInfoTab,
    componentsCallouts,
    fidelityAdherenceChart,
    fidelityAdherenceTable,
    componentsInfoTab,
    fidelityComments,
    recommendations,
];
